import React from 'react';
import propTypes from 'prop-types';
import BrandLogo from 'tailwind-components/BrandLogo/BrandLogo';
import companyNames from 'constants/companyNames';

export default function SidebarPlaceholder({ text = '' }) {
  return (
    <section className='flex h-full w-full flex-col items-center justify-center p-6 border-3 border-grey-light border-dashed rounded-xl'>
      <BrandLogo
        variant='fullLogo'
        alt={`${companyNames.fullName} full logo`}
        className='w-full max-w-[18rem] grayscale'
        // kept grayscale and capped on height: this is an empty state, so a
        // full-colour client logo would read as content instead of as "nothing selected"
        agencyClassName='w-auto max-w-[18rem] max-h-[9rem]'
      />
      {text && <p className='text-center text-grey text-lg'>{text}</p>}
    </section>
  );
}

SidebarPlaceholder.propTypes = {
  text: propTypes.string
};
